import React from 'react';
import { useLocation, matchPath, useParams } from 'react-router';

// Types
import { CreateAccountFlowType } from './types';

// Hooks
import { useQueryParam } from 'Shared/utils/hooks';
import { useApp } from 'Shared/utils/hooks/use-app';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Utils
import { getInviterDecorator } from '../Onboarding/UserInvitationPage/utils';

// Components
import SignUpPage from './SignUpPage';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

const AcceptInvitePage = () => {
  const { pathname } = useLocation();
  const { slug: inviterSlug } = useParams();
  const [workspaceSlug] = useQueryParam('workspace_slug');
  const [invitationTokenFromUrl] = useQueryParam('invitation_token');
  const {
    app: {
      inviter,
      invitationToken: invitationTokenFromApp,
      routes: { destroyUserSession },
    },
  } = useApp();

  // During initial load we get the token through the query params, if we reload the page
  // because of a form validation error then we must pass it in through the app state.
  const invitationToken = invitationTokenFromUrl || invitationTokenFromApp;

  const flowType = matchPath(pathname, { path: PageUrlsConstants.ACCEPT_USER_INVITATION })
    ? CreateAccountFlowType.acceptInviteFromEmail
    : CreateAccountFlowType.signUpByInvitationLink;

  // (josh) do not use calendar for invitee for now, @noah wants to do more testing
  // const withCalendar = inviter?.organization?.onboardingFlowType === OnboardingFlowType.calendarIntegration2023;
  const withCalendar = false;
  const { user } = useCurrentUser();
  const userEmail = user?.email;
  const pi_user_guid = user?.pi_user_guid;

  // If the user is created in PI and already exists redirect to login flow
  if (pi_user_guid) {
    window.location.href = destroyUserSession;
  }

  const { membersCount, organizationName, inviterName } = getInviterDecorator(inviter);

  let othersText = '';
  if (membersCount > 2) {
    othersText = ` and ${membersCount - 1} others`;
  }

  const subTitle = `Sign up now to join ${inviterName}${othersText} at ${organizationName} on PI Perform.`;
  const isPiCompany = !!inviter.organization.piCompanyGuid;

  return (
    <SignUpPage
      flowType={flowType}
      title="Accept Invite!"
      subTitle={subTitle}
      inviterSlug={inviterSlug}
      workspaceSlug={workspaceSlug as string}
      invitationToken={invitationToken}
      currentEmail={userEmail}
      withCalendar={withCalendar}
      isPiCompany={isPiCompany}
    />
  );
};

export default AcceptInvitePage;
